var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-section"},[_c('div',[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.pageTitle))])]),_c('div',[_vm._t("pageContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }